import '../../../User/association.scss';
import DoctorFilterPanel from 'src/Admin/components/User/Personas/Providers/Doctors';
const DoctorSelection = ({
  setHasDoctors,
  selectedDoctorsData,
  setSelectedDoctorsData,
}) => {
  const deleteSelectedDoctorId = (doctorId) => {
    console.log('createUserFormData before delete >>>', doctorId);
    setSelectedDoctorsData(
      [...selectedDoctorsData].filter((doc) => doc.ConnectorID !== doctorId),
    );
    if (
      [...selectedDoctorsData].filter((doc) => doc.ConnectorID !== doctorId)
        ?.length > 0
    ) {
      setHasDoctors(true);
    } else {
      setHasDoctors(false);
    }
  };

  const onSelectedDostorsCount = (length) => {
    console.log('length', length);
  };

  const onSelectedDoctorsList = (value) => {
    //handleValChange('doctors', value)
    console.log('value', value);
    setSelectedDoctorsData(value);
    if (value?.length > 0) {
      setHasDoctors(true);
    } else {
      setHasDoctors(false);
    }
  };

  const handleValChange = (event) => {
    console.log('event', event);
  };
  const nextStep = () => {
    console.log('nextStep values');
  };

  return (
    <div className="association-container">
      <h2 className="blob-permission-plan-section-heading mt-4">Provider</h2>
      <DoctorFilterPanel
        label={' Add Doctor'}
        updateSelectedItemCount={onSelectedDostorsCount}
        isContinueClicked={false}
        nextStep={nextStep}
        selectedItemsData={selectedDoctorsData}
        setSelectedItemsData={onSelectedDoctorsList}
        editAffiliatedRecords={true}
        onDeleteSelectedDoctor={(docId) => {
          deleteSelectedDoctorId(docId);
        }}
        handleValChange={handleValChange}
      />
    </div>
  );
};

export default DoctorSelection;
